const INTEGRATIONS = [
  "Revolut", "EBICS", "Stripe", "SEPA", "Qonto",
  "Wise", "GoCardless", "Pennylane", "Sage", "Xero"
];

export function Integrations() {
  return (
    <section className="integrations">
      <div className="integrations-label">Speaks fluently with the tools you already use</div>
      <div className="marquee">
        {[...INTEGRATIONS, ...INTEGRATIONS].map((name, idx) => (
          <div key={idx} className="marquee-item">{name}</div>
        ))}
      </div>
    </section>
  );
}
